import useApiUrl from './useApiUrl'

export default useApiUrl
